<div class="flex flex-col h-full bg-surface-50">
  <!-- Mobile Stage Indicator -->
  <div class="lg:hidden flex items-center bg-white border-b border-slate-100 px-4 py-3 shrink-0">
    @for (s of stageLabels; track s.id; let i = $index) {
      <div class="flex items-center" [class]="i + 1 < stageLabels.length ? 'flex-1' : ''">
        <div class="flex flex-col items-center gap-1">
          <div
            class="w-7 h-7 rounded-full flex items-center justify-center text-2xs font-bold transition-colors"
            [ngClass]="{
              'bg-emerald-500 text-white': stageStatuses()[i] === 'completed',
              'bg-navy-900 text-white': stageStatuses()[i] === 'active',
              'bg-slate-100 text-slate-400': stageStatuses()[i] === 'pending',
            }"
          >
            @if (stageStatuses()[i] === 'pending') {
              {{ i + 1 }}
            } @else {
              <img src="/icons/check-white-icon.svg" class="w-3 h-3" alt="" />
            }
          </div>
          <p
            class="text-2xs font-medium whitespace-nowrap transition-colors"
            [ngClass]="
              stageStatuses()[i] === 'active' ? 'text-navy-900 font-bold' : 'text-slate-400'
            "
          >
            {{ s.letter }}
          </p>
        </div>
        @if (i < stageLabels.length - 1) {
          <div class="flex-1 h-px bg-slate-200 mb-3.5"></div>
        }
      </div>
    }
  </div>

  <!-- Body -->
  <div class="flex flex-1 min-h-0">
    <!-- Sidebar — desktop only -->
    <aside
      class="hidden lg:flex lg:flex-col w-56 xl:w-64 shrink-0 bg-slate-400/8 border-r border-slate-100 p-6 xl:px-12 xl:py-10 overflow-y-auto"
    >
      <p class="text-sm font-bold text-navy-900 mb-0.5">Steps of the process</p>
      <p class="text-2xs text-slate-500 mb-7">Incident Workflow &amp; Oversight</p>

      <ol class="flex flex-col">
        @for (s of stageLabels; track s.id; let i = $index) {
          <li class="flex gap-3 h-16">
            <div class="flex flex-col items-center shrink-0">
              <div
                class="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-colors"
                [ngClass]="{
                  'bg-emerald-500 text-white': stageStatuses()[i] === 'completed',
                  'bg-navy-900 text-white': stageStatuses()[i] === 'active',
                  'border border-slate-400 text-slate-400': stageStatuses()[i] === 'pending',
                }"
              >
                @if (stageStatuses()[i] === 'pending') {
                  {{ i + 1 }}
                } @else {
                  <img src="/icons/check-white-icon.svg" class="w-3.5 h-3.5" alt="" />
                }
              </div>
              @if (i < stageLabels.length - 1) {
                <div class="w-px grow bg-slate-400"></div>
              }
            </div>
            <div class="pt-0.5 pb-5">
              <p class="text-2xs text-slate-700 mb-0.5">Stage {{ s.letter }}</p>
              <p
                class="text-xs transition-colors font-bold"
                [ngClass]="{
                  'text-emerald-500': stageStatuses()[i] === 'completed',
                  'font-bold text-navy-900': stageStatuses()[i] === 'active',
                  'text-slate-600': stageStatuses()[i] === 'pending',
                }"
              >
                {{ s.name }}
              </p>
            </div>
          </li>
        }
      </ol>
    </aside>

    <!-- Main Content -->
    <main class="flex-1 overflow-y-auto bg-white">
      <div class="max-w-4xl mx-auto px-4 py-5 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
        <app-incident-record
          [incident]="incident()"
          (saved)="onSaved()"
          (saveFailed)="onSaveFailed()"
        />
      </div>
    </main>
  </div>
</div>

@if (showUnsavedModal()) {
  <div class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-3xl w-full max-w-sm shadow-xl p-6">
      <p class="text-sm font-bold text-navy-900 mb-1">You have unsaved changes.</p>
      <p class="text-xs text-slate-500 mb-6">
        If you leave this page, your changes will not be saved.
      </p>
      <div class="flex flex-col gap-2">
        <button
          type="button"
          (click)="saveAndLeave()"
          class="w-full px-4 py-2.5 text-sm font-semibold text-white bg-accent-500 hover:opacity-90 rounded-xl transition-opacity cursor-pointer"
        >
          Save
        </button>
        <button
          type="button"
          (click)="confirmLeave()"
          class="w-full px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-navy-900 transition-colors cursor-pointer"
        >
          Discard
        </button>
      </div>
    </div>
  </div>
}

@if (showInvestigationModal() && incident()) {
  <app-new-investigation-modal
    [linkedIncidentId]="incident()!.id"
    [linkedIncidentLabel]="incident()!.incidentNumber"
    (closed)="showInvestigationModal.set(false)"
    (created)="showInvestigationModal.set(false)"
  />
}
